export default "__VITE_ASSET__BRT1ruzc__"